<h2 mat-dialog-title>Occupancy Day Settings</h2>

<mat-dialog-content class="p-fluid">

  <!-- EDITABLE METRICS GRID -->
  @if (metrics) {
    <div class="metrics-preview">
      <h4>Current → New Values</h4>
      <div class="metrics-grid grid-4">
        <!-- 1. pct -->
        <div class="metric-card">
          <div class="metric-label">{{ metricTooltips.pct }}</div>
          <div class="metric-row">
            <span class="old pct">{{ formatPct(metrics.pct) }}</span>
            <input type="number" pInputText [(ngModel)]="updates.pct" />
          </div>
        </div>
      </div>
    </div>
  }

  <div class="selection-row">
    <!-- OCC DEVIATION MULTISELECT -->
    <div class="p-field">
      <label>Occupancy Range</label>

      <p-listbox
        [options]="deviationOptions"
        [(ngModel)]="selectedDeviationIds"
        optionLabel="label"
        optionValue="value"
        [multiple]="true"
        [checkbox]="true"
        [showToggleAll]="true"
        [filter]="true"
        styleClass="w-100"
        >
      </p-listbox>
    </div>
    <!-- DAY MULTISELECT -->
    <div class="p-field">
      <label>Days to Arrival</label>

      <p-listbox
        [options]="dayOptions"
        [(ngModel)]="selectedDays"
        optionLabel="label"
        optionValue="value"
        [multiple]="true"
        [checkbox]="true"
        [showToggleAll]="true"
        styleClass="w-100"
        >
      </p-listbox>
    </div>
  </div>




</mat-dialog-content>

<mat-dialog-actions align="end">
  <!-- <button mat-button (click)="close()">Close</button> -->
  <button mat-stroked-button mat-dialog-close>
    Cancel
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="submit()"
    >
    Save
  </button>
</mat-dialog-actions>
